import { render, staticRenderFns } from "./ColumnRenew.vue?vue&type=template&id=aa6dd258"
import script from "./ColumnRenew.vue?vue&type=script&lang=ts"
export * from "./ColumnRenew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports